// This is more a demonstration of how to use the `ComponentConfig` constant.
// Subclasses of Component should override `ComponentConfig` with their own configuration (eg. `MyComponentConfig = {...}`).
// The three required properties are `componentTypeKey`, `baseHtmlClass` and `selector`.
// These properties are digested by the `Component` class constructor (via `props.config) and used to identify and initialize components.
// The `componentTypeKey` is used to identify the type of component.
// This unique value is used to prevent a component from being initialized more than once on an element.
// The `baseHtmlClass` is used to identify the element that is the root of the component.
// The `selector` is used to find HTML elements that are the root of the component (`this.element`).
// The `elementComponentsKey` is a key for a property that is added to an element that has components. The property stores the components that are initialized on an element.
// The `componentizedWithKey` is a key for a property that is added to an element that has components. The property stores the componentTypeKey strings of the components that are initialized on an element.

import {ComponentizedPropertyName} from "./component_constructor";

// We mark an element as initialized by adding this class modifier to the element's classList
// eg. "foo_component--inited". Generally only used to style the element differently once it is
// initialized. It lives here (rather than in component_initializer.js) because both the
// initializer — which builds the class — and `Component#destroy` — which removes it again —
// need it, and Component must not depend on the loader.
export const InitializedClassModifier = 'inited';

export const ComponentConfig = {
    componentTypeKey: 'Component',
    baseHtmlClass: 'component',
    selector: '.component',

    elementComponentsKey: 'components',
    componentizedWithKey: ComponentizedPropertyName,
}
